import { MAIN_IMAGE_ROOT } from "../../../app_config";
import MworkLogo from "../../../assets/logo.svg";
import { useNavigate } from "../../../helpers/navigationHelpers";
import { useVisualProvider } from "../useVisualProvider";

const Logo = () => {
  const navigate = useNavigate();
  const { logoUrl } = useVisualProvider();

  return logoUrl ? (
    <img
      onClick={() => navigate.goHome()}
      className="max-h-[40px] cursor-pointer sm:max-h-[56px]"
      src={`${MAIN_IMAGE_ROOT}${logoUrl}`}
    />
  ) : (
    <MworkLogo className="max-h-[56px] cursor-pointer" />
  );
};

export default Logo;
